module.exports = "https://coursera_assets.s3.amazonaws.com/images/e515b44295e1dc174fe6475b13d7263f.png";